export const globalNavHeightNumber = '54';
export const globalNavHeight = '54px';
export default globalNavHeight;